<template>
  <q-page padding>
    <div class="row col-12 justify-between align-center">
      <p class="text-h6 text-brand-1 text-weight-bolder">{{ title }}</p>
    </div>
    <div
      class="row col-12 row-input-container text-weight-bold text-brand-5 q-mt-md q-gutter-sm"
    >
      <div class="col-md col-xs-4 input-unidade-container">
        <div class="q-ml-sm no-margin-no-padding titulo-input-unidade">
          Unidade
        </div>
        <lista-unidades-select
          class="input-new-design"
          v-model="unidade"
        ></lista-unidades-select>
      </div>
      <div
        v-if="tipoRequisicao == 'balcao'"
        class="col-2 input-colaborador-container"
      >
        <div class="col-md col-xs-4 no-margin-no-padding titulo-input-unidade">
          Requisição Para
        </div>
        <q-select
          class="input-new-design"
          dense
          outlined
          v-model="requisicaoPara"
          :options="options"
        />
      </div>
      <div
        v-if="temPermissaoCracha() && requisicaoPara.value == 'colaborador'"
        class="col-md col-xs-4"
      >
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          :resetar="resetarFuncionario"
          debounce="500"
          :buscarPorCracha="true"
        />
      </div>
      <div v-if="requisicaoPara.value == 'colaborador'" class="col-md col-xs-3">
        <div class="texto-titulo-input">Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          @emitirFuncionario="receberFuncionario"
          :resetar="resetarFuncionario"
        />
      </div>
      <div v-if="requisicaoPara.value != 'visitante'" class="col-md col-xs-3">
        <div class="texto-titulo-input">Centro de Custo</div>

        <q-input
          v-model="centroCustoUsuario"
          dense
          outlined
          bg-color="brand-7"
          class="select input-new-design"
          disable
        />
      </div>
      <div
        v-if="requisicaoPara.value == 'visitante'"
        class="col-md-2 col-sm-6 col-xs-6 q-ml-xs"
      >
        <div class="texto-titulo-input">Centro de Custo</div>
        <SelecaoCentroCustos v-model="centroCusto" />
      </div>
      <div class="col-md col-xs-3">
        <div class="texto-titulo-input">Saldo Estoque</div>
        <q-select
          v-model="saldo"
          dense
          outlined
          map-options
          emit-value
          option-value="value"
          option-label="label"
          :options="saldoOptionsFiltered"
          :disable="isSaldoSelectDisabled"
          :bg-color="isSaldoSelectDisabled ? 'brand-7' : undefined"
          class="select input-new-design"
        />
      </div>
    </div>

    <div class="row col-12 q-my-xl">
      <div
        class="column col-4 text-brand-5 no-margin-no-padding text-weight-regular input-tipo-requisicao-container"
      >
        <div
          style="font-weight: 100; font-size: 16px"
          class="text-weight-bold text-brand-1 titulo-input-tipo-requisicao"
        >
          Selecione a condição dos produtos que serão listados
        </div>
        <div class="row q-mt-sm radio-container">
          <q-radio
            val="all"
            label="Todos"
            v-model="filtroTipoRequisicao"
            :disable="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-produto-todos'
              ) != -1
            "
          ></q-radio>
          <q-radio
            v-if="
              requisicaoPara.value == 'colaborador' ||
              tipoRequisicao == 'requisicaoMaterial'
            "
            val="liberados"
            label="Produtos Liberados"
            v-model="filtroTipoRequisicao"
            :disable="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-produto-liberados'
              ) != -1
            "
          ></q-radio>
          <q-radio
            v-if="requisicaoPara.value != 'visitante'"
            val="yes"
            label="Todos EPI"
            v-model="filtroTipoRequisicao"
            :disable="
              $store.state.autenticacao.usuarioLogado.permissoes.gmapi.roles.indexOf(
                'voucher-produto-epis'
              ) != -1
            "
          ></q-radio>
        </div>
      </div>
    </div>

    <div v-show="unidade?.id">
      <NovaRequisicaoTabelas
        :unidade="unidade.id"
        :filtroTipoRequisicao="filtroTipoRequisicao"
        :tipoRequisicao="tipoRequisicao"
        :requisicaoPara="requisicaoPara.value"
        :solicitantePesquisaProp="solicitantePesquisa"
        :solicitanteMatriculaProp="solicitanteMatricula"
        :centroSelecionadoProps="centroCusto"
        :category="category"
        @listaSolicitantes="getListaSolicitante"
        :tipoSaldo="saldo"
      />
    </div>
  </q-page>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";

import NovaRequisicaoTabelas from "../components/NovaRequisicaoTabelas.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import SelecaoFuncionario from "../../ferramentaria/components/SelecaoFuncionario.vue";
import SelecaoCentroCustos from "../components/SelecaoCentroCustos.vue";

export default {
  props: ["category", "title"],
  name: "NovaRequisicao",
  components: {
    NovaRequisicaoTabelas,
    ListaUnidadesSelect,
    SelecaoFuncionario,
    SelecaoCentroCustos,
  },
  setup() {
    const store = useStore();

    const ativo2 = ref(true);
    let unidade = ref("");
    let filtroTipoRequisicao = ref(null);
    const solicitanteMatricula = ref(null);
    const solicitantePesquisa = ref(null);
    const listarSolicitantes = ref([]);
    const saldo = ref("");
    const resetarFuncionario = ref(0);
    const centroCusto = ref(null);
    const tipoRequisicao = ref("balcao");
    const centroCustoUsuario = ref(null);
    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);
    const options = ref([
      {
        label: "Colaborador",
        value: "colaborador",
      },
      {
        label: "Visitante",
        value: "visitante",
      },
    ]);
    let requisicaoPara = ref({
      label: options.value[0].label,
      value: options.value[0].value,
    });

    const temPermissaoComSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-com-saldo"
        ) || false
      );
    });

    const temPermissaoSemSaldo = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-mostrar-sem-saldo"
        ) || false
      );
    });

    const isSaldoSelectDisabled = computed(() => {
      return temPermissaoComSaldo.value || temPermissaoSemSaldo.value;
    });

    const saldoOptionsFiltered = computed(() => {
      if (temPermissaoComSaldo.value) {
        return [{ label: "Com Saldo", value: "com-saldo" }];
      }
      if (temPermissaoSemSaldo.value) {
        return [{ label: "Sem Saldo", value: "sem-saldo" }];
      }
      return [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ];
    });

    const inicializarSaldoBasedoNasPermissoes = () => {
      if (temPermissaoComSaldo.value) {
        saldo.value = "com-saldo";
      } else if (temPermissaoSemSaldo.value) {
        saldo.value = "sem-saldo";
      } else {
        saldo.value =
          store.state.autenticacao.cliente.includes("acciona") ||
          store.state.autenticacao.cliente.includes("staging-acciona")
            ? "com-saldo"
            : "";
      }
    };

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
      }
    );

    watch(
      () => requisicaoPara.value,
      () => {
        if (requisicaoPara.value.value == "visitante") {
          filtroTipoRequisicao.value = "all";
          solicitanteMatricula.value = "";
          solicitantePesquisa.value = "";
        }
      }
    );

    const getListaSolicitante = (lista) => {
      listarSolicitantes.value = lista.map((e) => {
        return { labelBase: `${e.name} - ${e.email}`, ...e };
      });
    };

    const receberFuncionario = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;

      centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;
    };

    const receberFuncionarioPorCracha = (value) => {
      solicitanteMatricula.value = value;
      solicitantePesquisa.value = value?.nome;

      centroCustoUsuario.value = `${value.centroCustoCode} - ${value.centroCustoName}`;
    };

    watch(
      () => requisicaoPara.value,
      () => {
        resetarFuncionario.value++;
      }
    );

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch("requisicao/listarFuncionarios", {
          card_id: card_id,
          vendor_id: unidade.value?.id,
        });

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionario(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    onMounted(() => {
      inicializarSaldoBasedoNasPermissoes();
    });

    return {
      unidade,

      ativo2,
      filtroTipoRequisicao,
      tipoRequisicao,
      options,
      requisicaoPara,
      solicitanteMatricula,
      solicitantePesquisa,
      receberFuncionario,
      receberFuncionarioPorCracha,
      resetarFuncionario,
      centroCusto,
      filterFn(val, update) {
        solicitantePesquisa.value = val;
        setTimeout(() => {
          update();
        }, 300);
      },
      listarSolicitantes,
      getListaSolicitante,
      centroCustoUsuario,
      saldoOptions: [
        { label: "Todos", value: "" },
        { label: "Com Saldo", value: "com-saldo" },
        { label: "Sem Saldo", value: "sem-saldo" },
      ],
      saldo,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      buscarPorCracha,
      temPermissaoCracha,
      isSaldoSelectDisabled,
      saldoOptionsFiltered,
    };
  },
};
</script>

<style scoped>
.ativo {
  color: white !important;
  background-color: #2d3e6e !important;
  border-radius: 3px;
}
.ativo2 {
  color: white !important;
  background-color: #2b5070 !important;
  border-radius: 3px;
}

.titulo-input-tipo-requisicao {
  font-size: 18px;
}

.radio-margin-top {
  margin-top: 36px;
}

@media only screen and (max-width: 768px) {
  .text-h6 {
    font-size: 1.2rem !important;
    text-align: center;
  }

  .input-unidade-container,
  .input-colaborador-container {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
    padding: 0;
  }

  .col-md,
  .col-2 {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-bottom: 16px;
  }

  .row-input-container {
    flex-direction: column !important;
    gap: 0 !important;
    margin: 0;
  }

  .input-tipo-requisicao-container {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    margin-top: 20px;
    padding: 0;
  }

  .radio-container {
    flex-direction: column !important;
  }

  .radio-container .q-radio {
    margin-bottom: 12px;
  }

  .titulo-input-unidade,
  .texto-titulo-input,
  .texto-titulo-select {
    font-size: 12px !important;
    margin-bottom: 4px;
  }

  .titulo-input-tipo-requisicao {
    font-size: 14px !important;
  }

  .input-new-design {
    margin-bottom: 16px;
  }

  .q-page {
    padding: 12px !important;
  }

  .no-margin-no-padding {
    padding: 0;
    margin: 0;
  }

  .q-ml-xs {
    margin-left: 0 !important;
  }
}

@media only screen and (max-width: 390px) {
  .text-h6 {
    font-size: 1.1rem !important;
  }

  .titulo-input-tipo-requisicao {
    font-size: 13px !important;
  }

  .q-page {
    padding: 8px !important;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
